import { render, staticRenderFns } from "./PapersShowcase.vue?vue&type=template&id=b63267c4&scoped=true&"
import script from "./PapersShowcase.vue?vue&type=script&lang=js&"
export * from "./PapersShowcase.vue?vue&type=script&lang=js&"
import style0 from "./PapersShowcase.vue?vue&type=style&index=0&id=b63267c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63267c4",
  null
  
)

export default component.exports